import Box from '@mui/material/Box'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	faFontAwesomeLogoFull
} from '@fortawesome/free-solid-svg-icons/faFontAwesomeLogoFull'

interface LabelChipProps {
	labelColor: string
	labelName: string
}

export const LabelChip = (props: LabelChipProps) => {
	const { labelColor, labelName } = props

	return (
		<Box
			component="span"
			sx={{
				display: 'flex',
				gap: 1,
				p: '3px 12px',
				color: '#ffffff',
				backgroundColor: labelColor || '#4B6687',
				width: 'fit-content',
				borderRadius: '4px'
			}}
		>
			<FontAwesomeIcon
				icon={faFontAwesomeLogoFull}
				style={{ color: '#ffffff', alignSelf: 'center', paddingBottom: 2 }}
			/>
			{labelName || 'Label name required'}
		</Box>
	)
}